import { render, staticRenderFns } from "./AiPlanner.vue?vue&type=template&id=1ab22aa2&scoped=true"
import script from "./AiPlanner.vue?vue&type=script&lang=js"
export * from "./AiPlanner.vue?vue&type=script&lang=js"
import style0 from "./AiPlanner.vue?vue&type=style&index=0&id=1ab22aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab22aa2",
  null
  
)

export default component.exports